<template>
<div class="mx-auto">
  <Loading :isLoading= "this.isLoading" />
  <div>
    <p class="title">Referencia de Pago de Inscripción</p>
    <p class="description">
      Para realizar el pago de su inscripción a FONCABSA puede hacerlo por medio de transferencia bancaria
      o pago en banco con la siguiente referencia:
    </p>

    <div>
      <p class="subtitle" style="margin-top:15px;margin-bottom:0px;">
        Referencia:
      </p>
      <p class="subtitleValue" style="margin-top:0px;">
        #133180000127863072
      </p>
      <p class="subtitle" style="margin-top:15px;margin-bottom:0px;">
        Banco:
      </p>
      <p class="subtitleValue" style="margin-top:0px;">
        ACTINVER SA
      </p>
    </div>
    
    <div style="display:flex;justify-content:center;margin-top:90px;">
      <div class="grid grid-cols-3 gap-4 container-grid">
        <div class="col-span-3">
          <input class="button_popups" type="button" value="Ir a la página principal" v-on:click="reedirect('/cuenta/principal')" />
        </div>
      </div>
    </div>
  </div>
</div>
</template>



<script>
import Loading from "@/components/Loading/VueLoading.vue";
import {getTokenDecoden} from "@/helpers/tokenauth";

export default {
  data() {
    return {
      personId: null,
      admissionStatus: "",
      slideIndex: 1,
      isLoading: false,
      voucherUploaded: false,
      ccapi: process.env.VUE_APP_CCAPI,
      urlWeb: process.env.VUE_APP_URLWEB,
      confirmPayment: false,
    }
  },
  name: 'ReferenciaDePagoComponent',
  props: {
    msg: String
  },
  components: {
    Loading
  },
  mounted() {
    this.loadInfo();
  },
  beforeMount() {
  },
  methods:{
    loadInfo() {
      var auth = getTokenDecoden();
      this.personId = auth["person_id"];
    },
    Logout(){
      sessionStorage.clear();
      //localStorage.clear();
      // window.location.href = "/"
      this.$router.push({path:"/"});
    },
    reedirect(url) {
      // window.location.href = url;
      this.$router.push({path:url});
    }
  }
}
</script>

<style>
.button_popups {
  border-radius: 5px;
  background-color: #FEB72B;
  color: #fff;
  font-family: Roboto;
  font-weight:400;
  width: 100%;
  height: 40px;
  padding:10px;
  font-size:16px;
}

.button_popups_no_background {
  border-radius: 5px;
  border: 1px solid #222222;
  background-color: #fff;
  color: #222222;
  font-family: Roboto;
  font-weight:400;
  width: 100%;
  height: 40px;
  padding:10px;
  font-size:16px;
}

.container-grid {
  width: 100%;
}

.upload_button {
  border-radius: 5px;
  background-color: #DEA610;
  color: #fff;
  font-weight:bold;
  width: 100%;
  height: 100%;
  padding: 10px;
  font-size:14px;
}

.inputsForm {
  border: 1px solid #d8d8d8;
  border-radius: 5px;
}

.italic {
  font-style: italic;
}
.title {
  font-size:30px;
  font-family:Roboto;
  color: #BFD243;
  font-weight: 500;
  margin-top:0px;
  text-align:left;
}

.description {
  font-size:20px;
  font-family:Roboto;
  color: #000;
  font-weight: 300;
  margin-top:0px;
  text-align:left;
}

.subtitle {
  font-size:20px;
  font-family:Roboto;
  color: #000;
  font-weight: 300;
  text-align:left;
}

.subtitleValue {
  font-size:20px;
  font-family:Roboto;
  color: #000;
  font-weight: 500;
  text-align: left;
}
@media only screen and (min-width: 1024px) {
  .container-grid {
    width: 40%;
  }

  .title {
    text-align:center;
  }

  .description {
    text-align:center;
  }
  .subtitle {
    text-align: center;
  }

  .subtitleValue {
    text-align: center;
  }
}

</style>